import { createFetchFunc } from "../helpers";

export default {
  FETCH_MY_PROFILE: createFetchFunc("myProfile"),
  FETCH_MANAGED_PROVIDERS: createFetchFunc("managedProviders"),
  SELECT_PROVIDER: (state, payload) => {
    state.selectedProvider = +payload;
  },
};
